import { isNonNullish, } from 'remeda';
export function cx(...parts) {
    return parts
        .filter(isNonNullish)
        .map(part => {
        if (typeof part === 'object') {
            return Object.entries(part)
                .filter(([_, isActive]) => isActive)
                .map(([css]) => css)
                .join(' ');
        }
        return part;
    })
        .join(' ');
}
export function depsEqual(a, b) {
    if (a.length !== b.length) {
        return false;
    }
    for (let i = 0; i < a.length; i++) {
        if (!Object.is(a[i], b[i])) {
            return false;
        }
    }
    return true;
}
//# sourceMappingURL=ReactUtils.js.map